export default __webpack_public_path__ + "static/media/predict.1a0dfbb8.svg";